import { pathRedirect } from '@/utils/auth'

import Dashboard from '@/containers/LeakageControl/Dashboard'

export default {
  path: 'leakageControl',
  redirect: pathRedirect,
  children: [
    { path: 'dashboard', component: Dashboard }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/leakageControl.js